/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_No_DraftInputs */

const en_us2_plan_no_draft = /** @type {(inputs: Plan_No_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There is no draft plan to review.`)
};

const pt_br2_plan_no_draft = /** @type {(inputs: Plan_No_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não há rascunho de plano para revisar.`)
};

const es_419_plan_no_draft = /** @type {(inputs: Plan_No_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay un borrador de plan para revisar.`)
};

const pt_pt2_plan_no_draft = /** @type {(inputs: Plan_No_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não há nenhum rascunho de plano para rever.`)
};

const fr_fr2_plan_no_draft = /** @type {(inputs: Plan_No_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il n'y a pas de brouillon de programme à examiner.`)
};

const de_de2_plan_no_draft = /** @type {(inputs: Plan_No_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es gibt keinen Planentwurf zum Prüfen.`)
};

const it_it2_plan_no_draft = /** @type {(inputs: Plan_No_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non c'è nessuna bozza di scheda da rivedere.`)
};

/**
* | output |
* | --- |
* | "There is no draft plan to review." |
*
* @param {Plan_No_DraftInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_no_draft = /** @type {((inputs?: Plan_No_DraftInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_No_DraftInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_no_draft(inputs)
	if (locale === "es-419") return es_419_plan_no_draft(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_no_draft(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_no_draft(inputs)
	if (locale === "de-DE") return de_de2_plan_no_draft(inputs)
	if (locale === "it-IT") return it_it2_plan_no_draft(inputs)
	return en_us2_plan_no_draft(inputs)
});
export { plan_no_draft as "plan.no_draft" }